<template>
    <div class="text-center mt-2" v-if="success">
        <strong v-html="successbody"></strong>
    </div>
    <form v-else>
        <div class="form-group">
            <input id="name" :class="['form-control',  {'is-invalid': form.errors.has('name')}]" v-model="form.name" type="text" required>
            <label for="name">{{ name }}</label>
        </div>
        <div class="form-group">
            <input id="company" class="form-control" :placeholder="company" v-model="form.company" type="text">
            <label for="company">{{ company }}</label>
        </div>
        <div class="form-group">
            <input id="phone" class="form-control" :placeholder="phone" v-model="form.phone" type="text">
            <label for="phone">{{ phone }}</label>
        </div>
        <div class="form-group">
            <input id="email" :class="['form-control',  {'is-invalid': form.errors.has('email')}]" v-model="form.email" class="form-control" type="text" required>
            <label for="email">{{ email }}</label>
        </div>
        <div class="form-group">
            <textarea id="text" :class="['form-control',  {'is-invalid': form.errors.has('text')}]" v-model="form.text" required></textarea>
            <label for="text">{{ text }}</label>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-xxl-6">
                <div class="checkbox">
                    <label>
                        <input name="policy" value="1" type="checkbox" v-model="form.privacy" />
                        <span :class="{'is-invalid': form.errors.has('privacy')}" v-html="privacy"></span>
                    </label>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-xxl-6">
                <div class="checkbox">
                    <label>
                        <input name="news" value="1" type="checkbox" v-model="form.news" />
                        <span v-html="news"></span>
                    </label>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-xxl-5 text-center">
                <button class="btn btn-primary" type="submit" @click.prevent="submit">{{ btn }}</button>
            </div>
        </div>
    </form>
</template>

<script>
import to from '@Utils/to'
import Request from '@Utils/request'

export default {
    props: {
        name: {
            default:  ""
        },
        company: {
            default:  ""
        },
        phone: {
            default:  ""
        },
        email: {
            default:  ""
        },
        text: {
            default:  ""
        },
        privacy: {
            default:  ""
        },
        news: {
            default:  ""
        },
        successbody: {
            default:  ""
        },
        btn: {
            default:  ""
        }
    },

    data() {
        return {
            success: false,
            loading: false,
            form: new Request({
                name: '',
                company: '',
                phone: '',
                email: '',
                text: '',
                privacy: false,
                news: false
            })
        }
    },

    methods: {
        async submit() {
            this.loading = true;
            let [err, response] = await to(this.form.post('contact'))
            this.success = response && response.success
            this.loading = false;
        }
    }
}
</script>


<style lang="scss" scoped>
    .invalid-feedback {
        color: red;
    }
</style>
